<template>
    <!-- Show if state.showDontKnowCards is set to false -->
    <div v-if="!state.showDontKnowCards">
        <h2 v-if="title">{{ title }}</h2>
        <ul :class="{ scrolly: cardsToChooseFrom.length > 10 }">
            <li v-for="(card, key) in cardsToChooseFrom" :key="key">
                <Card :description="card.description" @click="saveChoice(card, selection)"/>
            </li>
        </ul>
        <div class="buttonContainer">
            <button v-if="backEnabled" @click="goBack">Takaisin</button>
            <button v-if="state.dontKnowCardsAreActive" @click="showDontKnowCards">Selaa "En osaa sanoa" -kortteja</button>
        </div>
    </div>

    <!-- Show if state.showDontKnowCards is set to true -->
    <div v-if="state.showDontKnowCards">
        <h2 v-if="title">{{ title }}</h2>
        <ul>
            <li v-for="(card, key) in state.dontKnowCards" :key="key">
                <Card :description="card.description" @click="saveChoice(card, selection)"/>
            </li>
        </ul>
        <button @click="hideDontKnowCards">Palaa takaisin</button>
    </div>
</template>

<script>

import Card from "./Card.vue";
import Answer from "./Answer.vue";
import CardTypeSelection from './CardTypeSelection.vue';
import { reactive } from 'vue';

export default {
    name: "Overlay",
    props: {
        // Card array containing the shown cards to choose from
        cardsToChooseFrom: Object,
        // Which place the card is selected for
        selectionType: String,
        // Tells if don't know cards are enabled to choose from
        dontKnowCardsAreActive: Boolean,
        // Tells if back button is enabled
        backEnabled: Boolean,
        title: String,
    },
    components: {
        Card,
        Answer,
        CardTypeSelection
    },
    setup(props, {emit}) {
        const state = reactive({ dontKnowCardsAreActive: props.dontKnowCardsAreActive, showDontKnowCards: false, dontKnowCards: {} });

        const saveChoice = (card) => {
            // Pass the selected card and selection place to parent
            emit('saveCardChoice', card, props.selectionType);
        }

        const goBack = () => {
            emit('goBack');
        }

        const showDontKnowCards = () => {
            const cardArray = JSON.parse(localStorage.getItem("cardArray"));
            state.dontKnowCards = cardArray.filter(card => {
                if (card.phase1selection === "EnOsaaSanoa" && !card.phase2selection)
                    return card;
            });
            state.showDontKnowCards = true;
        }

        const hideDontKnowCards = () => {
            state.showDontKnowCards = false;
        }

        return { saveChoice, goBack, state, showDontKnowCards, hideDontKnowCards };
    },
    emits: ['saveCardChoice', 'goBack'],
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body, #answerBox {
    margin: 0px;
    padding: 0px;
}

h2 {
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: var(--a_color);
}

.buttonContainer {
    width: 100%;
    height: 50px;
}

.buttonContainer button {
    margin: auto 10px;
}

li .card {
   width: 40vw;
}

li:hover {
    filter: brightness(50%) !important;
    transition: filter 250ms ease;
}

li .card:hover {
    cursor: pointer;
}

#triangleImage {
    margin: 10px;
    cursor: pointer;
}

.scrolly {
    height: 63vh;
    overflow-y: scroll;
}

@media only screen and (max-width: 750px) {
    ul {
        height: 63vh;
        overflow-y: scroll;
    }
}


@media only screen and (max-width: 510px) {
    button {
        margin-top: 3px !important;
        margin-bottom: 3px !important;
    }
}
</style>
